import axios from "axios";
import { config } from "../config";
import { authenticate, createResponseErrorHandler } from "./interceptors";

const queryParams = new URLSearchParams(location.search);
const elrondUriParam = queryParams.get("elrondUri");

export const elrondUri = elrondUriParam ? elrondUriParam : config.elrond.url;

export const elrondApi = axios.create({ baseURL: elrondUri });

elrondApi.interceptors.request.use(authenticate);
elrondApi.interceptors.response.use((response) => response, createResponseErrorHandler(elrondApi));
